import { useReducer } from 'react';
import { newSftpUserReducer } from './newSftpUserReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  NewSftpUserDispatchContext,
  NewSftpUserStateContext,
} from './useNewSftpUserContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface INewUserProviderProps {
  children: any;
  value?: IValue;
}

export function NewSftpUserProvider({
  children,
  value = { initialState: defaultContextValues, reducer: newSftpUserReducer },
}: INewUserProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <NewSftpUserStateContext.Provider value={state}>
      <NewSftpUserDispatchContext.Provider value={dispatch}>{children}</NewSftpUserDispatchContext.Provider>
    </NewSftpUserStateContext.Provider>
  );
}
